import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { CrmPermissionStateService } from '../auth/services/crm-permission-state.service';
import {
  CPD_MY_PAGE_KEY,
  CPD_TEAM_PAGE_KEY,
  canViewCpdPage,
  hasCpdModuleAccess,
} from './cpd-permissions';

export const matchCpdModuleRoute: CanMatchFn = () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const permissionState = inject(CrmPermissionStateService);
  const router = inject(Router);

  if (!hasCpdModuleAccess(permissionState)) {
    return router.parseUrl('/dashboard');
  }

  return true;
};

export const matchCpdMyRoute: CanMatchFn = () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const permissionState = inject(CrmPermissionStateService);
  const router = inject(Router);

  if (!hasCpdModuleAccess(permissionState)) {
    return router.parseUrl('/dashboard');
  }

  if (canViewCpdPage(permissionState, CPD_MY_PAGE_KEY)) {
    return true;
  }

  if (canViewCpdPage(permissionState, CPD_TEAM_PAGE_KEY)) {
    return router.parseUrl('/cpd/team-cpd');
  }

  return router.parseUrl('/dashboard');
};

export const matchCpdTeamRoute: CanMatchFn = () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const permissionState = inject(CrmPermissionStateService);
  const router = inject(Router);

  if (!hasCpdModuleAccess(permissionState)) {
    return router.parseUrl('/dashboard');
  }

  if (canViewCpdPage(permissionState, CPD_TEAM_PAGE_KEY)) {
    return true;
  }

  if (canViewCpdPage(permissionState, CPD_MY_PAGE_KEY)) {
    return router.parseUrl('/cpd');
  }

  return router.parseUrl('/dashboard');
};
